export default "__VITE_ASSET__CCrjoHHQ__"